import React from 'react';
import Loading from './Loading';
import CompleteLoading from './CompleteLoading';
import firebase from '../utils/firebaseSetUp';
import OrderItem from './OrderItem';

import $ from 'jquery';

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

// Function to check stock availability and return insufficient stock items
const checkStockAvailability = async productos => {
  const insufficientStock = [];
  const productRefs = [];

  // First pass: collect all product references and check availability
  for (const producto of productos) {
    const productQuery = firebase
      .firestore()
      .collection('productos')
      .where('codigo', '==', producto.codigo)
      .limit(1);

    const productSnapshot = await productQuery.get();

    if (productSnapshot.empty) {
      throw new Error(`Producto con código ${producto.codigo} no encontrado`);
    }

    const productDoc = productSnapshot.docs[0];
    const productData = productDoc.data();
    const currentAvailability = productData.disponibilidad || 0;

    if (currentAvailability < producto.cantidad) {
      insufficientStock.push({
        codigo: producto.codigo,
        nombre: producto.nombre,
        requested: producto.cantidad,
        available: currentAvailability,
      });
    }

    productRefs.push({
      ref: productDoc.ref,
      data: productData,
      cantidad: producto.cantidad,
    });
  }

  return { insufficientStock, productRefs };
};

// Function to discount inventory when order is accepted (allows negative stock)
const discountInventoryAllowNegative = async productos => {
  const productRefs = [];

  // First collect all product references outside the transaction
  for (const producto of productos) {
    const productQuery = firebase
      .firestore()
      .collection('productos')
      .where('codigo', '==', producto.codigo)
      .limit(1);

    const productSnapshot = await productQuery.get();

    if (productSnapshot.empty) {
      throw new Error(`Producto con código ${producto.codigo} no encontrado`);
    }

    const productDoc = productSnapshot.docs[0];
    const productData = productDoc.data();

    productRefs.push({
      ref: productDoc.ref,
      data: productData,
      cantidad: producto.cantidad,
    });
  }

  // Now run the transaction with the collected references
  return firebase.firestore().runTransaction(async transaction => {
    // Update all products within the transaction (allowing negative stock)
    for (const productRef of productRefs) {
      const newAvailability =
        productRef.data.disponibilidad - productRef.cantidad;

      transaction.update(productRef.ref, {
        disponibilidad: newAvailability,
        actualizado: firebase.firestore.Timestamp.now(),
      });
    }

    return { success: true };
  });
};

// Legacy function to discount inventory when order is accepted (throws error on insufficient stock)
const discountInventory = async productos => {
  const result = await checkStockAvailability(productos);

  // If there's insufficient stock, throw an error
  if (result.insufficientStock.length > 0) {
    const errorMessage = result.insufficientStock
      .map(
        item =>
          `${item.nombre} (${item.codigo}): solicitado ${item.requested}, disponible ${item.available}`
      )
      .join(', ');
    throw new Error(`Stock insuficiente: ${errorMessage}`);
  }

  // Proceed with discounting inventory
  return firebase.firestore().runTransaction(async transaction => {
    // Update all products within the transaction
    for (const productRef of result.productRefs) {
      const newAvailability =
        productRef.data.disponibilidad - productRef.cantidad;

      transaction.update(productRef.ref, {
        disponibilidad: newAvailability,
        actualizado: firebase.firestore.Timestamp.now(),
      });
    }

    return { success: true };
  });
};

export default class Orders extends React.Component {
  _ordersListener;
  _mounted;
  constructor(props) {
    super(props);

    this.state = {
      completeLoading: '',
      orders: [],
      loadMore: false,
      lastDocument: null,
      loadMorePending: false,
      search: '',
      screen: 0,
      data: null,
      viewMode: 'table',
      showTrash: false,
      showStockConfirmation: false,
      insufficientStockItems: [],
      pendingOrderToAccept: null,
      pendingOrderIndex: null,
    };
  }

  loadMoreOrders = () => {
    if (this._mounted) {
      this.setState({
        loadMorePending: true,
      });
    }

    let base = firebase.firestore().collection('ventas');

    if (this.state.search !== '') {
      base = base.where(
        'palabrasClave',
        'array-contains',
        String(this.state.search).toLowerCase()
      );
    }

    // Apply soft delete filter at Firebase query level
    if (this.state.showTrash) {
      base = base
        .where('eliminado', '==', true)
        .orderBy('eliminado')
        .orderBy('creado', 'desc');
    } else {
      // When not in trash mode, show all orders (both deleted and non-deleted)
      // We'll filter and style them in the UI
      base = base.orderBy('creado', 'desc');
    }

    base
      .startAfter(this.state.lastDocument)
      .limit(10)
      .get()
      .then(snap => {
        let orders = [];

        snap.forEach(doc => {
          let data = doc.data();
          data.id = doc.id;
          orders.push(data);
        });

        if (this._mounted) {
          this.setState({
            orders: this.state.orders.concat(orders),
            loadMore: snap.docs.length < 10 ? false : true,
            lastDocument: snap.docs[snap.docs.length - 1],
            pending: false,
            loadMorePending: false,
          });
        }
      })
      .catch(e => {
        console.log(e);
        if (this._mounted) {
          this.setState({
            loadMorePending: false,
            loadMore: false,
          });
        }
      });
  };

  getOrders = () => {
    if (this._mounted) {
      this.setState({
        pending: true,
      });
    }

    if (this._ordersListener !== undefined) {
      this._ordersListener(); //CLean the listener
    }
    let base = firebase.firestore().collection('ventas');

    if (this.state.search !== '') {
      base = base.where(
        'palabrasClave',
        'array-contains',
        String(this.state.search).toLowerCase()
      );
    }

    // Apply soft delete filter at Firebase query level
    if (this.state.showTrash) {
      base = base
        .where('eliminado', '==', true)
        .orderBy('eliminado')
        .orderBy('creado', 'desc');
    } else {
      // When not in trash mode, show all orders (both deleted and non-deleted)
      // We'll filter and style them in the UI

      base = base.orderBy('creado', 'desc');
    }

    this._ordersListener = base.limit(10).onSnapshot(
      snap => {
        let orders = [];

        snap.forEach(doc => {
          let data = doc.data();
          data.id = doc.id;
          orders.push(data);
        });

        if (this._mounted) {
          this.setState({
            orders: orders,
            loadMore: snap.docs.length < 10 ? false : true,
            lastDocument: snap.docs[snap.docs.length - 1],
            pending: false,
          });
        }
      },
      e => {
        console.log(e);
        if (this._mounted) {
          this.setState({
            pending: false,
            loadMore: false,
          });
        }
      }
    );
  };

  componentDidMount() {
    this._mounted = true;

    this.getOrders();

    $('.special-search').on('keypress', e => {
      if (e.which == 13) {
        this.getOrders();
      }
    });
  }

  componentWillUnmount() {
    this._mounted = false;

    if (this._ordersListener !== undefined) {
      this._ordersListener(); //Clean the listener
    }
  }

  render() {
    return (
      <div
        className="container-fluid fade-in"
        style={{
          paddingLeft:
            this.props.device === 'small'
              ? '20px'
              : this.props.navStatus === 'expanded'
              ? '320px'
              : '100px',
          paddingTop: '20px',
          paddingRight: '20px',
          paddingBottom: '20px',
        }}
      >
        {this.state.completeLoading !== '' ? (
          <CompleteLoading message={this.state.completeLoading} />
        ) : null}
        {this.state.isLoading ? <Loading /> : null}

        {/* Stock Confirmation Dialog */}
        {this.state.showStockConfirmation ? (
          <div
            className="modal show d-block"
            style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title text-warning">
                    <i className="material-icons align-middle mr-2">warning</i>
                    Stock Insuficiente
                  </h5>
                </div>
                <div className="modal-body">
                  <p>Los siguientes productos no tienen suficiente stock:</p>
                  <ul className="list-group mb-3">
                    {this.state.insufficientStockItems.map((item, index) => (
                      <li
                        key={index}
                        className="list-group-item d-flex justify-content-between"
                      >
                        <div>
                          <strong>{item.nombre}</strong> ({item.codigo})
                        </div>
                        <div className="text-muted">
                          Solicitado: {item.requested} | Disponible:{' '}
                          {item.available}
                        </div>
                      </li>
                    ))}
                  </ul>
                  <p className="text-warning">
                    <i
                      className="material-icons align-middle mr-1"
                      style={{ fontSize: '18px' }}
                    >
                      warning
                    </i>
                    ¿Está seguro que desea proceder? Esto permitirá que el stock
                    sea negativo.
                  </p>
                  <div className="alert alert-light border mt-3">
                    <small className="text-muted">
                      <strong>Nota:</strong> Solo los pedidos aprobados
                      descuentan inventario. Los pedidos pendientes no afectan
                      el stock hasta ser aprobados.
                    </small>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      if (this._mounted) {
                        this.setState({
                          showStockConfirmation: false,
                          insufficientStockItems: [],
                          pendingOrderToAccept: null,
                          pendingOrderIndex: null,
                        });
                      }
                    }}
                  >
                    Cancelar
                  </button>
                  <button
                    type="button"
                    className="btn btn-warning"
                    onClick={() => {
                      if (this._mounted) {
                        this.setState({
                          showStockConfirmation: false,
                          completeLoading: 'Aprobando Venta',
                        });
                      }

                      // Proceed with accepting the order even with insufficient stock
                      this.acceptOrderWithNegativeStock(
                        this.state.pendingOrderToAccept,
                        this.state.pendingOrderIndex
                      );
                    }}
                  >
                    <i
                      className="material-icons align-middle mr-1"
                      style={{ fontSize: '18px' }}
                    >
                      check
                    </i>
                    Proceder
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <h2 className="text-center font-weight-bold">Pedidos</h2>

        <div className="alert alert-info mt-3" role="alert">
          <i
            className="material-icons align-middle mr-2"
            style={{ fontSize: '18px' }}
          >
            info
          </i>
          <strong>Gestión de Inventario:</strong> El stock solo se descuenta
          cuando se aprueba un pedido. Los pedidos pendientes no afectan el
          inventario hasta ser aprobados.
        </div>

        {this.state.screen === 0 ? (
          <>
            <div className="input-group mb-3 mt-4">
              <input
                type="text"
                value={this.state.search}
                className="form-control special-search"
                placeholder="Search"
                onChange={e => {
                  if (this._mounted) {
                    this.setState({
                      search: e.currentTarget.value,
                    });
                  }
                }}
              />
              <div className="input-group-append">
                <button
                  className="btn btn-primary"
                  onClick={this.getOrders}
                  type="submit"
                >
                  <i
                    className="material-icons align-middle"
                    style={{ fontSize: '18px' }}
                  >
                    search
                  </i>
                </button>
              </div>
            </div>

            <div className="mb-3 d-flex justify-content-between">
              <div>
                <button
                  className={`btn ${
                    this.state.showTrash ? 'btn-success' : 'btn-outline-danger'
                  }`}
                  onClick={() => {
                    if (this._mounted) {
                      this.setState(
                        prev => ({
                          showTrash: !prev.showTrash,
                          orders: [], // Clear existing orders
                          lastDocument: null, // Reset pagination
                          loadMore: false, // Reset load more state
                        }),
                        () => this.getOrders()
                      );
                    }
                  }}
                >
                  <i className="material-icons align-middle">delete</i>
                  <span className="ml-2">
                    {this.state.showTrash ? 'Ver activos' : 'Papelera'}
                  </span>
                </button>
              </div>
              <div className="btn-group" role="group">
                <button
                  type="button"
                  className={`btn ${
                    this.state.viewMode === 'table'
                      ? 'btn-primary'
                      : 'btn-outline-primary'
                  }`}
                  onClick={() => {
                    if (this._mounted) {
                      this.setState({ viewMode: 'table' });
                    }
                  }}
                >
                  <i
                    className="material-icons align-middle"
                    style={{ fontSize: '18px' }}
                  >
                    table_chart
                  </i>
                  <span className="ml-1">Tabla</span>
                </button>
                <button
                  type="button"
                  className={`btn ${
                    this.state.viewMode === 'card'
                      ? 'btn-primary'
                      : 'btn-outline-primary'
                  }`}
                  onClick={() => {
                    if (this._mounted) {
                      this.setState({ viewMode: 'card' });
                    }
                  }}
                >
                  <i
                    className="material-icons align-middle"
                    style={{ fontSize: '18px' }}
                  >
                    view_module
                  </i>
                  <span className="ml-1">Tarjetas</span>
                </button>
              </div>
            </div>

            {this.state.pending === true ? (
              <div className="flex-left mt-2">
                <div className="spinner-border"></div>
              </div>
            ) : (
              (() => {
                if (this.state.orders.length === 0) {
                  return (
                    <div className="text-center text-muted mt-4">
                      {this.state.showTrash
                        ? 'No hay ventas en la papelera'
                        : 'No hay ventas'}
                    </div>
                  );
                }
                if (this.state.viewMode === 'table') {
                  return (
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th>Cliente</th>
                            <th>Vendedor</th>
                            <th>Estado</th>
                            <th>Total</th>
                            <th>Creado</th>
                            <th className="text-right">Acciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.orders.map((order, idx) => (
                            <tr
                              key={order.id || idx}
                              className={
                                !this.state.showTrash && order.eliminado
                                  ? 'table-secondary'
                                  : ''
                              }
                              style={
                                !this.state.showTrash && order.eliminado
                                  ? {
                                      opacity: 0.6,
                                      textDecoration: 'line-through',
                                    }
                                  : {}
                              }
                            >
                              <td>{order.nombreCliente}</td>
                              <td>{order.vendedor}</td>
                              <td>
                                <span
                                  className={`${
                                    order.estadoAprobacion === 'pendiente'
                                      ? 'primary-text'
                                      : order.estadoAprobacion === 'aprobado'
                                      ? 'text-success'
                                      : 'text-danger-2'
                                  }`}
                                >
                                  {capitalize(order.estadoAprobacion)}
                                </span>
                              </td>
                              <td>
                                {Math.round((order.total || 0) * 100) / 100}
                              </td>
                              <td>
                                {order.creado && order.creado.toDate
                                  ? `${order.creado.toDate().getDate()}-${
                                      order.creado.toDate().getMonth() + 1
                                    }-${order.creado
                                      .toDate()
                                      .getFullYear()} ${order.creado
                                      .toDate()
                                      .getHours()}:${order.creado
                                      .toDate()
                                      .getMinutes()}`
                                  : ''}
                              </td>
                              <td className="text-right">
                                {!this.state.showTrash ? (
                                  <>
                                    <button
                                      className="btn btn-sm btn-light mr-2"
                                      title="Ver"
                                      onClick={() =>
                                        this.setState({
                                          data: order,
                                          screen: 1,
                                        })
                                      }
                                    >
                                      <i className="material-icons align-middle">
                                        visibility
                                      </i>
                                    </button>
                                    {order.eliminado ? (
                                      <button
                                        className="btn btn-sm btn-secondary mr-2"
                                        title="Restaurar"
                                        onClick={() =>
                                          this.handleRestoreOrder(order)
                                        }
                                      >
                                        <i className="material-icons align-middle">
                                          restore
                                        </i>
                                      </button>
                                    ) : (
                                      <>
                                        {order.estadoAprobacion ===
                                        'pendiente' ? (
                                          <>
                                            <button
                                              className="btn btn-sm btn-success mr-2"
                                              title="Aprobar"
                                              onClick={() => {
                                                this.handleAcceptOrder(
                                                  order,
                                                  -1
                                                );
                                              }}
                                            >
                                              <i className="material-icons align-middle">
                                                check
                                              </i>
                                            </button>
                                            <button
                                              className="btn btn-sm btn-warning mr-2"
                                              title="Rechazar"
                                              onClick={() =>
                                                this.denyOrder(order)
                                              }
                                            >
                                              <i className="material-icons align-middle">
                                                block
                                              </i>
                                            </button>
                                          </>
                                        ) : null}
                                        <button
                                          className="btn btn-sm btn-danger"
                                          title="Enviar a papelera"
                                          onClick={() =>
                                            this.softDeleteOrder(order)
                                          }
                                        >
                                          <i className="material-icons align-middle">
                                            delete
                                          </i>
                                        </button>
                                      </>
                                    )}
                                  </>
                                ) : (
                                  <>
                                    <button
                                      className="btn btn-sm btn-secondary mr-2"
                                      title="Restaurar"
                                      onClick={() =>
                                        this.handleRestoreOrder(order)
                                      }
                                    >
                                      <i className="material-icons align-middle">
                                        restore
                                      </i>
                                    </button>
                                    <button
                                      className="btn btn-sm btn-danger"
                                      title="Eliminar definitivamente"
                                      onClick={() =>
                                        this.hardDeleteOrder(order)
                                      }
                                    >
                                      <i className="material-icons align-middle">
                                        delete_forever
                                      </i>
                                    </button>
                                  </>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  );
                }

                let elements = [];

                for (let i = 0; i < this.state.orders.length; i += 2) {
                  elements.push(
                    <div className="row m-0" key={i}>
                      <div className="col-lg-6 m-0 p-2">
                        <OrderItem
                          showTrash={this.state.showTrash}
                          changeState={(id, value) => {
                            if (this._mounted) {
                              this.setState({
                                completeLoading: 'Actualizando Venta...',
                              });
                            }

                            firebase
                              .firestore()
                              .collection('usuarios')
                              .doc(id)
                              .update({
                                activo: value,
                              })
                              .then(() => {
                                if (this._mounted) {
                                  this.setState({
                                    completeLoading: '',
                                  });
                                }

                                this.props.addToast('Vendedor actualizado!');
                              })
                              .catch(e => {
                                console.log(e);
                                if (this._mounted) {
                                  this.setState({
                                    completeLoading: '',
                                  });
                                }
                                this.props.addToast('Algo salió mal');
                              });
                          }}
                          order={this.state.orders[i]}
                          accept={() => {
                            this.handleAcceptOrder(this.state.orders[i], i);
                          }}
                          delete={() =>
                            this.softDeleteOrder(this.state.orders[i])
                          }
                          restore={() =>
                            this.handleRestoreOrder(this.state.orders[i])
                          }
                          deny={() => {
                            if (this._mounted) {
                              this.setState({
                                completeLoading: 'Rechazando Venta',
                              });
                            }

                            // Simply update the order status - no stock changes needed since order was never approved
                            firebase
                              .firestore()
                              .collection('ventas')
                              .doc(this.state.orders[i].id)
                              .update({
                                estadoAprobacion: 'rechazado',
                              })
                              .then(() => {
                                if (this._mounted) {
                                  this.setState({
                                    completeLoading: '',
                                  });
                                }
                                this.props.addToast('Venta Rechazada!');
                              })
                              .catch(e => {
                                console.log(e);
                                if (this._mounted) {
                                  this.setState({
                                    completeLoading: '',
                                  });
                                }
                                this.props.addToast('Algo salió mal');
                              });
                          }}
                          view={() => {
                            if (this._mounted) {
                              this.setState({
                                data: this.state.orders[i],
                                screen: 1,
                              });
                            }
                          }}
                        />
                      </div>

                      <div className="col-lg-6 p-2 m-0">
                        {i + 1 === this.state.orders.length ? null : (
                          <OrderItem
                            showTrash={this.state.showTrash}
                            view={() => {
                              if (this._mounted) {
                                this.setState({
                                  data: this.state.orders[i + 1],
                                  screen: 1,
                                });
                              }
                            }}
                            changeState={(id, value) => {
                              if (this._mounted) {
                                this.setState({
                                  completeLoading: 'Actualizando Vendedor...',
                                });
                              }

                              firebase
                                .firestore()
                                .collection('usuarios')
                                .doc(id)
                                .update({
                                  activo: value,
                                })
                                .then(() => {
                                  if (this._mounted) {
                                    this.setState({
                                      completeLoading: '',
                                    });
                                  }

                                  this.props.addToast('Vendedor actualizado!');
                                })
                                .catch(e => {
                                  console.log(e);
                                  if (this._mounted) {
                                    this.setState({
                                      completeLoading: '',
                                    });
                                  }
                                  this.props.addToast('Algo salió mal');
                                });
                            }}
                            order={this.state.orders[i + 1]}
                            accept={() => {
                              this.handleAcceptOrder(
                                this.state.orders[i + 1],
                                i + 1
                              );
                            }}
                            delete={() =>
                              this.softDeleteOrder(this.state.orders[i + 1])
                            }
                            restore={() =>
                              this.handleRestoreOrder(this.state.orders[i + 1])
                            }
                            deny={() => {
                              if (this._mounted) {
                                this.setState({
                                  completeLoading: 'Rechazando Venta',
                                });
                              }

                              // Simply update the order status - no stock changes needed since order was never approved
                              firebase
                                .firestore()
                                .collection('ventas')
                                .doc(this.state.orders[i + 1].id)
                                .update({
                                  estadoAprobacion: 'rechazado',
                                })
                                .then(() => {
                                  if (this._mounted) {
                                    this.setState({
                                      completeLoading: '',
                                    });
                                  }
                                  this.props.addToast('Venta Rechazada!');
                                })
                                .catch(e => {
                                  console.log(e);
                                  if (this._mounted) {
                                    this.setState({
                                      completeLoading: '',
                                    });
                                  }
                                  this.props.addToast('Algo salió mal');
                                });
                            }}
                          />
                        )}
                      </div>
                    </div>
                  );
                }

                return elements;
              })()
            )}

            {this.state.loadMore === true ? (
              <div className="mt-4 flex-center">
                {this.state.loadMorePending ? (
                  <div className="spinner-border"></div>
                ) : (
                  <a
                    onClick={e => {
                      e.preventDefault();
                      this.loadMoreOrders();
                    }}
                  >
                    Cargar más
                  </a>
                )}
              </div>
            ) : null}
          </>
        ) : null}

        {this.state.screen === 1 ? (
          <div className="container-fluid mt-4 show-in">
            <div className="flex-left">
              <button
                className="btn btn-danger btn-sm"
                onClick={() => {
                  if (this._mounted) {
                    this.setState(
                      {
                        screen: 0,
                      },
                      () => {}
                    );
                  }
                }}
              >
                <i className="material-icons align-middle">arrow_back</i>
                <span className="ml-2">Atras</span>
              </button>
            </div>

            <h3 className="mt-5">Información</h3>

            <div className="white-card mt-3">
              <div className="row">
                <div className="col-sm-6 m-0">
                  <label>Cliente</label>
                  <h5>{this.state.data.nombreCliente}</h5>
                </div>
                <div className="col-sm-6 m-0">
                  <label>Vendedor</label>
                  <h5>{this.state.data.vendedor}</h5>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-sm-6 m-0">
                  <label>Forma de Pago</label>
                  <h5>
                    {this.state.data.formaPago === 0
                      ? 'Pago en dólares'
                      : this.state.data.formaPago === 1
                      ? 'Pago en bolivares'
                      : this.state.formaPago === 2
                      ? 'Contado'
                      : 'Crédito'}
                  </h5>
                </div>

                <div className="col-sm-6 m-0">
                  <label>Creado</label>
                  <h5>
                    {this.state.data.creado.toDate().getDate() +
                      '-' +
                      (this.state.data.creado.toDate().getMonth() + 1) +
                      '-' +
                      this.state.data.creado.toDate().getFullYear() +
                      ' ' +
                      this.state.data.creado.toDate().getHours() +
                      ':' +
                      this.state.data.creado.toDate().getMinutes()}
                  </h5>
                </div>
              </div>

              <div className="row mt-3">
                <div className="col-sm-6 m-0">
                  <label>Estado</label>
                  <h5
                    className={`${
                      this.state.data.estadoAprobacion === 'pendiente'
                        ? 'primary-text'
                        : this.state.data.estadoAprobacion === 'aprobado'
                        ? 'text-success'
                        : 'text-danger-2'
                    }`}
                  >
                    {capitalize(this.state.data.estadoAprobacion)}
                  </h5>
                </div>
              </div>
            </div>

            <h3 className="mt-4">Total</h3>

            <div className="white-card mt-3">
              <div className="row mx-0">
                <div className="col-sm-6 m-0">
                  <label>Sub Total</label>
                  <h5>{Math.round(this.state.data.subTotal * 100) / 100}</h5>
                </div>
                <div className="col-sm-6 m-0">
                  <label>Total</label>
                  <h5>{Math.round(this.state.data.total * 100) / 100}</h5>
                </div>
              </div>
            </div>

            <h4 className="mt-4">Información Adicional</h4>

            <div className="white-card mt-3">
              <div className="row mx-0">
                <div className="col-sm-12">
                  <label>Comentarios</label>
                  <h5>
                    {this.state.data.observaciones !== undefined &&
                    this.state.data.observaciones
                      ? this.state.data.observaciones
                      : 'No especificado'}
                  </h5>
                </div>
              </div>
            </div>

            <h3 className="mt-4">Productos</h3>

            <div className="table-responsive mt-3">
              <table className="table">
                <thead>
                  <th>Código</th>
                  <th>Nombre</th>
                  <th>Precio USD</th>
                  <th>Cantidad</th>
                </thead>
                <tbody>
                  {this.state.data.productos.map((e, i) => {
                    return (
                      <tr key={i}>
                        <td>{e.codigo}</td>
                        <td>{e.nombre}</td>
                        <td>{e.precioUSD}</td>
                        <td>{e.cantidad}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  softDeleteOrder = order => {
    if (this._mounted) {
      this.setState({ completeLoading: 'Enviando venta a la papelera' });
    }

    const batch = firebase.firestore().batch();

    // Only restore stock if the order was previously approved
    if (
      order.estadoAprobacion === 'aprobado' &&
      order.productos &&
      order.productos.length
    ) {
      for (let j = 0; j < order.productos.length; j++) {
        const p = order.productos[j];
        batch.update(
          firebase.firestore().collection('productos').doc(p.idProducto),
          {
            actualizado: new Date(),
            disponibilidad: firebase.firestore.FieldValue.increment(p.cantidad),
          }
        );
      }
    }

    batch.update(firebase.firestore().collection('ventas').doc(order.id), {
      eliminado: true,
      deletedAt: new Date(),
    });

    batch
      .commit()
      .then(() => {
        if (this._mounted) {
          this.setState({ completeLoading: '' });
        }
        this.props.addToast('Venta enviada a la papelera');
      })
      .catch(e => {
        console.log(e);
        if (this._mounted) {
          this.setState({ completeLoading: '' });
        }
        this.props.addToast('Algo salió mal');
      });
  };

  handleRestoreOrder = async order => {
    try {
      // Only check stock availability if the order was previously approved
      if (order.estadoAprobacion === 'aprobado') {
        const stockResult = await checkStockAvailability(order.productos);

        if (stockResult.insufficientStock.length > 0) {
          // Show confirmation dialog for insufficient stock
          if (this._mounted) {
            this.setState({
              showStockConfirmation: true,
              insufficientStockItems: stockResult.insufficientStock,
              pendingOrderToAccept: order,
              pendingOrderIndex: null, // Not needed for restore
            });
          }
          return;
        }
      }

      // If stock is sufficient or order was never approved, proceed with restore
      await this.restoreOrderWithInventory(order);
    } catch (e) {
      console.log(e);
      if (this._mounted) {
        this.setState({ completeLoading: '' });
      }
      this.props.addToast('Algo salió mal');
    }
  };

  restoreOrder = async order => {
    try {
      if (this._mounted) {
        this.setState({ completeLoading: 'Restaurando venta' });
      }

      // First discount inventory to restore the stock deduction
      await discountInventoryAllowNegative(order.productos);

      // Then update order status to restore it
      await firebase
        .firestore()
        .collection('ventas')
        .doc(order.id)
        .update({ eliminado: false, deletedAt: null });

      if (this._mounted) {
        this.setState({ completeLoading: '' });
      }
      this.props.addToast('Venta restaurada e inventario actualizado');
    } catch (e) {
      console.log(e);
      if (this._mounted) {
        this.setState({ completeLoading: '' });
      }
      this.props.addToast('Algo salió mal');
    }
  };

  restoreOrderWithInventory = async order => {
    try {
      if (this._mounted) {
        this.setState({ completeLoading: 'Restaurando venta' });
      }

      // Only discount inventory if the order was previously approved
      if (order.estadoAprobacion === 'aprobado') {
        await discountInventoryAllowNegative(order.productos);
      }

      // Then update order status to restore it
      await firebase
        .firestore()
        .collection('ventas')
        .doc(order.id)
        .update({ eliminado: false, deletedAt: null });

      if (this._mounted) {
        this.setState({ completeLoading: '' });
      }

      // Show appropriate message based on whether inventory was updated
      if (order.estadoAprobacion === 'aprobado') {
        this.props.addToast('Venta restaurada e inventario actualizado');
      } else {
        this.props.addToast('Venta restaurada');
      }
    } catch (e) {
      console.log(e);
      if (this._mounted) {
        this.setState({ completeLoading: '' });
      }
      this.props.addToast('Algo salió mal');
    }
  };

  hardDeleteOrder = order => {
    if (this._mounted) {
      this.setState({ completeLoading: 'Eliminando definitivamente' });
    }

    firebase
      .firestore()
      .collection('ventas')
      .doc(order.id)
      .delete()
      .then(() => {
        if (this._mounted) {
          this.setState({ completeLoading: '' });
        }
        this.props.addToast('Venta eliminada definitivamente');
      })
      .catch(e => {
        console.log(e);
        if (this._mounted) {
          this.setState({ completeLoading: '' });
        }
        this.props.addToast('Algo salió mal');
      });
  };

  handleAcceptOrder = async (order, orderIndex) => {
    try {
      // First check stock availability
      const stockResult = await checkStockAvailability(order.productos);

      if (stockResult.insufficientStock.length > 0) {
        // Show confirmation dialog for insufficient stock
        if (this._mounted) {
          this.setState({
            showStockConfirmation: true,
            insufficientStockItems: stockResult.insufficientStock,
            pendingOrderToAccept: order,
            pendingOrderIndex: orderIndex,
          });
        }
        return;
      }

      // If stock is sufficient, proceed normally
      if (this._mounted) {
        this.setState({
          completeLoading: 'Aprobando Venta',
        });
      }

      // First discount inventory, then update order status
      await discountInventory(order.productos);

      await firebase.firestore().collection('ventas').doc(order.id).update({
        estadoAprobacion: 'aprobado',
      });

      if (this._mounted) {
        this.setState({
          completeLoading: '',
        });
      }

      this.props.addToast('Venta Aprobada e Inventario Actualizado!');
    } catch (e) {
      console.log(e);
      if (this._mounted) {
        this.setState({
          completeLoading: '',
        });
      }

      // Show specific error message for inventory issues
      if (e.message.includes('Stock insuficiente')) {
        this.props.addToast(`Error: ${e.message}`);
      } else {
        this.props.addToast('Algo salió mal');
      }
    }
  };

  acceptOrderWithNegativeStock = async (order, orderIndex) => {
    try {
      // Check if this is a restore operation (orderIndex is null for restore)
      if (orderIndex === null) {
        // This is a restore operation - only discount inventory if order was previously approved
        if (order.estadoAprobacion === 'aprobado') {
          await discountInventoryAllowNegative(order.productos);
        }

        await firebase.firestore().collection('ventas').doc(order.id).update({
          eliminado: false,
          deletedAt: null,
        });

        if (this._mounted) {
          this.setState({
            completeLoading: '',
            insufficientStockItems: [],
            pendingOrderToAccept: null,
            pendingOrderIndex: null,
          });
        }

        // Show appropriate message based on whether inventory was updated
        if (order.estadoAprobacion === 'aprobado') {
          this.props.addToast(
            'Venta restaurada e inventario actualizado! (Stock negativo permitido)'
          );
        } else {
          this.props.addToast('Venta restaurada');
        }
      } else {
        // This is an accept operation - always discount inventory
        await discountInventoryAllowNegative(order.productos);

        await firebase.firestore().collection('ventas').doc(order.id).update({
          estadoAprobacion: 'aprobado',
        });

        if (this._mounted) {
          this.setState({
            completeLoading: '',
            insufficientStockItems: [],
            pendingOrderToAccept: null,
            pendingOrderIndex: null,
          });
        }

        this.props.addToast(
          'Venta Aprobada e Inventario Actualizado! (Stock negativo permitido)'
        );
      }
    } catch (e) {
      console.log(e);
      if (this._mounted) {
        this.setState({
          completeLoading: '',
          insufficientStockItems: [],
          pendingOrderToAccept: null,
          pendingOrderIndex: null,
        });
      }
      this.props.addToast('Algo salió mal');
    }
  };

  denyOrder = order => {
    if (this._mounted) {
      this.setState({ completeLoading: 'Rechazando Venta' });
    }

    // Simply update the order status - no stock changes needed since order was never approved
    firebase
      .firestore()
      .collection('ventas')
      .doc(order.id)
      .update({
        estadoAprobacion: 'rechazado',
      })
      .then(() => {
        if (this._mounted) {
          this.setState({ completeLoading: '' });
        }
        this.props.addToast('Venta Rechazada!');
      })
      .catch(e => {
        console.log(e);
        if (this._mounted) {
          this.setState({ completeLoading: '' });
        }
        this.props.addToast('Algo salió mal');
      });
  };
}
